import React, { useState } from 'react'; //, useContext, useEffect 
// import { Label, Form, Input, Button} from 'reactstrap'; //, InputGroup, InputGroupText 
import { Box, TextField, Button, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { register as registerUser } from '../context/actions/auth/register';
import type { IContact } from '../interfaces/IContact';
import '../css/registrationform.scss';


interface ICourse {
    shortName: string;
    name: string;
    day: IDay;
    isVisible: boolean;
    nbMaxRegistrations: number;
    startTime: string;
    endTime: string;
}

interface IStage {
    shortName: string;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
}

interface IDay {
    name: string;
}

interface ICourseObj {
    course: ICourse;
    subscribes: IContact[];
    nbSubscribes: number;
}

interface IProps {
    courses: undefined | ICourseObj[];
    stages: undefined | IStage[];
    title: string;
}


interface IRegistrationForm {
    course: string;
    stage: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    phoneNumber: string;
    // address: string;
    street: string;
    postalCode: string;
    city: string;
    emailAddress: string;
    emailAddress1: string;
    emailAddress2: string;
    isachild: boolean;
}

const defaultRegistrationForm = {
    course: "",
    stage: "",
    firstName: "",
    lastName: "",
    birthDate: "",
    phoneNumber: "",
    // address: "",
    street: "",
    postalCode: "",
    city: "",
    emailAddress: "",
    emailAddress1: "",
    emailAddress2: "",
    isachild: true
}

const niceTime = (time: string) => {
    if (time === null)
        return '';
    const tokens = time.split(':');
    return `${tokens[0]}h${tokens[1]}`;
};

const monthToString = (month: number) => {
    const monthList = ['Janvier', 'Février', 'Mars',
        'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre',
        'Octobre', 'Novembre', 'Décembre'];
    return monthList[month];
};
const nicePeriod = (startDate: string, endDate: string) => {
    if (startDate === null)
        return '';
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start.getMonth() === end.getMonth() && start.getDate() < end.getDate()) {
        return `${start.getDate()} au ${end.getDate()} ${monthToString(start.getMonth())}`;
    }
    return '';
};

type Props = {
    isAChild: boolean;
    setIsAChild: (value: boolean) => void;
};

export function IsChildCheckbox({ isAChild, setIsAChild }: Props) {
    return (
        <Box className="registration-form-is-a-child">
            <FormControlLabel
                control={
                    <Checkbox
                        id="isachild"
                        name="isachild"
                        checked={isAChild}
                        onChange={(e) => setIsAChild(e.target.checked)}
                        color="primary"
                    />
                }
                label="J'inscris mon enfant"
            />
        </Box>
    );
}

const RegistrationForm = ({ stages, courses, title }: IProps) => {
    const [form, setForm] = useState<IRegistrationForm>(defaultRegistrationForm);
    const [course, setCourse] = useState("Choisir votre cours");
    const [stage, setStage] = useState("Choisir votre stage");
    const [isAChild, setIsAChild] = useState<boolean>(true);
    const [emailError, setEmailError] = useState<string>("");

    const onSubmit = (e: React.FormEvent, form: any) => {
        e.preventDefault();
        registerUser(form);
        alert("Merci pour votre inscription! Nous vous confirmons celle-ci dans les plus brefs délais en fonction des places disponibles pour le.s cours sélectionné.s.");
    };

    const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    //const hasEmailError = !(pattern.test(form.emailAddress1) && pattern.test(form.emailAddress2));
    const checkEmailErrors = (): void => {
        setEmailError("");
        if (isAChild) {
            if (form.emailAddress1 && !pattern.test(form.emailAddress1))  {
                setEmailError("La première adresses e-mail n'est pas valide");
                return;
            }
            if (form.emailAddress2 && !pattern.test(form.emailAddress2)) {
                setEmailError("La deuxième adresses e-mail n'est pas valide");
                return;
            }
            if (!form.emailAddress1 && !form.emailAddress2) 
                setEmailError("Veuillez entrer au moins une adresse e-mail");
            return;
        }
        if (!form.emailAddress) {
            setEmailError("Veuillez entrer une adresse e-mail");
            return;
        }
        if (!pattern.test(form.emailAddress)) {
            setEmailError("L'adresse e-mail n'est pas valide");
        }
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
        checkEmailErrors();
    };

    const updateCourse: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
        setCourse(e.target.value);
        setForm({ ...form, [e.target.id]: e.target.value });
    };

    const updateStage: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
        setStage(e.target.value);
        setForm({ ...form, [e.target.id]: e.target.value });
    };

    return (
        <Box component="form"
            className="registration-form content-width"
            method="post"
            onSubmit={(e) => onSubmit(e, form)}
            sx={(theme) => ({
                // backgroundColor: theme.palette.mode === "dark" ? "#f00" : "#00f", // ici même couleur
                // color: theme.palette.mode === "dark" ? "#f00" : "#00f",
                // mx: 'auto',
                // p: { xs: 2, sm: 2 },
                // maxWidth: 1200,
                // display: 'flex',
                // flexDirection: 'column',
                // gap: 3,
                '& .MuiFormLabel-asterisk': { color: 'red' },
                '& .MuiInputLabel-root': { color: theme.palette.mode === "dark" ? "#AAA" : "#AAA" }
            })}
        // sx={(theme) => ({
        //     backgroundColor: theme.palette.mode === "dark" ? "#fff" : "#fff", // ici même couleur
        //     borderRadius: 1,
        //     textDecorationColor: "#f00",
        //     color: theme.palette.mode === "dark" ? "#000" : "#000",
        //     accentColor: "#0f0",
        // })}
        >
            <Typography variant="h4" component="h2">
                Merci de remplir votre fiche de pré-inscription :
            </Typography>

            <div className="registration-form-course" >
                {courses !== undefined ?
                    <select name="course" id="course" value={course} onChange={updateCourse}>
                        <option key='default' value=''>{title}</option>
                        {
                            courses.filter((li) => li.course.isVisible && li.nbSubscribes < li.course.nbMaxRegistrations).map((li) => {
                                const schedule = li.course.day?.name !== '' ? ` (${li.course.day?.name} de ${niceTime(li.course.startTime)} à ${niceTime(li.course.endTime)})` : '';
                                return (
                                    <option key={li.course.shortName} value={li.course.shortName}>{li.course.name}{schedule}</option>
                                );
                            })
                        }
                    </select>
                    : <div />
                }
                {stages !== undefined ?
                    <select name="stage" id="stage" value={stage} onChange={updateStage}>
                        <option key='default' value=''>{title}</option>
                        {
                            stages.map((li) => {
                                const schedule = li.startDate !== undefined ? ` (Du ${nicePeriod(li.startDate, li.endDate)})` : '';
                                return (
                                    <option key={li.shortName} value={li.shortName}>{li.description}{schedule}</option>
                                );
                            })
                        }
                    </select>
                    : <div />
                }
            </div>

            <Box className="registration-form-is-a-child">
                <IsChildCheckbox isAChild={isAChild} setIsAChild={setIsAChild} />
                {/*<Label className="checkbox" htmlFor="isachild">
                    <Input type="checkbox" onClick={() => setIsAChild(!isAChild)} checked={isAChild} id="isachild" name="isachild" />
                J'inscris mon enfant
              </Label> */}
            </Box>

            {/* <div className="registration-form-name registration-form-item">
                <Label>Prénom et nom (de l'enfant)<span className="mandatory">*</span></Label>
                <div className="flex">
                    <div className="registration-form-name__first-name">
                        <Input type="text" id="firstName" name="firstName" autoComplete="first-name" onChange={onChange} placeholder="Prénom" />
                    </div>
                    <div className="registration-form-name__last-name">
                        <Input type="text" id="lastName" name="lastName" autoComplete="family-name" onChange={onChange} placeholder="Nom" />
                    </div>
                </div>
            </div> */}

            <Box className="registration-form-name registration-form-item">
                <Box component="label" sx={{ display: "block", mb: 1 }}>
                    Prénom et nom (de l'enfant)<span className="mandatory">*</span>
                </Box>

                <Box className="flex" sx={{ gap: 2 }}>
                    <Box className="registration-form-name__first-name" sx={{ flex: 1 }}>
                        <TextField
                            required
                            id="firstName"
                            name="firstName"
                            label="Prénom"
                            variant="outlined"
                            autoComplete="given-name"      // plus standard que "first-name"
                            onChange={onChange}
                            fullWidth
                        // sx={(theme) => ({
                        //     backgroundColor: theme.palette.mode === "dark" ? "#fff" : "#fff", // ici même couleur
                        //     borderRadius: 1,
                        //     textDecorationColor: "#f00",
                        //     color: theme.palette.mode === "dark" ? "#000" : "#000",
                        //     accentColor: "#0f0",
                        // })}
                        />
                    </Box>

                    <Box className="registration-form-name__last-name" sx={{ flex: 1 }}>
                        <TextField
                            required
                            id="lastName"
                            name="lastName"
                            label="Nom"
                            variant="outlined"
                            autoComplete="family-name"
                            onChange={onChange}
                            fullWidth
                        />
                    </Box>
                </Box>
            </Box>

            {/* <div className="registration-form-birthdate registration-form-item">
                <Label>Date de naissance (de l'enfant)<span className="mandatory">*</span></Label>
                <Input type="text" id="birthDate" name="birthDate" autoComplete="date" onChange={onChange} />
            </div> */}

            <Box className="registration-form-birthdate registration-form-item">
                <Box component="label" sx={{ display: "block", mb: 1 }}>
                    Date de naissance (de l'enfant)<span className="mandatory">*</span>
                </Box>
                <TextField
                    id="birthDate"
                    name="birthDate"
                    label="Date de naissance"
                    // variant="outlined"
                    // Si tu veux un picker natif :
                    type="date"
                    value={form.birthDate ?? ""} // string au format "YYYY-MM-DD"
                    // Remplace l'ancien InputLabelProps par slotProps.inputLabel
                    slotProps={{
                        inputLabel: { shrink: true }, // évite que le label chevauche la valeur
                        input: {
                            inputProps: {
                                max: new Date().toISOString().slice(0, 10), // "YYYY-MM-DD"
                                // min: "1900-01-01",
                            },
                        },
                    }}
                    // Optionnel : contrainte de date (exemple, pas de date future)
                    autoComplete="bday"
                    onChange={onChange}
                    fullWidth
                />
            </Box>


            {/* <div className="flex space-between addresses registration-form-item">
                <div className="registration-form-address">
                <Label>Adresse<span className="mandatory">*</span></Label>
                    <div className="flex">
                        <p>Rue : </p>
                        <Input type="text" id="street" name="street" autoComplete="street" onChange={onChange} />                        
                    </div>
                    <div className="flex">
                        <p>Code postal : </p>
                        <Input type="text" id="postalCode" name="postalCode" autoComplete="postalCode" onChange={onChange} />                        
                    </div>
                    <div className="flex">
                        <p>Ville : </p>
                        <Input type="text" id="city" name="city" autoComplete="city" onChange={onChange} />
                    </div>
                </div>
            </div> */}
            <Box className="flex space-between addresses registration-form-item" sx={{ gap: 2 }}>
                <Box className="registration-form-address" sx={{ flex: 1 }}>
                    <Box component="label" sx={{ display: "block", mb: 1 }}>
                        Adresse<span className="mandatory">*</span>
                    </Box>

                    <Box className="flex" sx={{ alignItems: "center", gap: 1, mb: 1 }}>
                        {/* <Typography component="span">Rue :</Typography> */}
                        <TextField
                            id="street"
                            name="street"
                            label="Rue"
                            variant="outlined"
                            autoComplete="street-address"
                            onChange={onChange}
                            fullWidth
                        />
                    </Box>

                    <Box className="flex" sx={{ alignItems: "center", gap: 1, mb: 1 }}>
                        {/* <Typography component="span">Code postal :</Typography> */}
                        <TextField
                            id="postalCode"
                            name="postalCode"
                            label="Code postal"
                            variant="outlined"
                            autoComplete="postal-code"
                            onChange={onChange}
                            fullWidth
                        />
                    </Box>

                    <Box className="flex" sx={{ alignItems: "center", gap: 1 }}>
                        {/* <Typography component="span">Ville :</Typography> */}
                        <TextField
                            id="city"
                            name="city"
                            label="Ville"
                            variant="outlined"
                            autoComplete="address-level2"
                            onChange={onChange}
                            fullWidth
                        />
                    </Box>
                </Box>
            </Box>

            {/* <div className="registration-form-phone registration-form-item">
                <Label>Numéro de téléphone<span className="mandatory">*</span></Label>
                <Input type="text" id="phoneNumber" name="phoneNumber" autoComplete="phone" onChange={onChange} />
            </div> */}
            <Box className="registration-form-phone registration-form-item">
                <Box component="label" sx={{ display: "block", mb: 1 }}>
                    Numéro de téléphone<span className="mandatory">*</span>
                </Box>
                <TextField
                    id="phoneNumber"
                    name="phoneNumber"
                    label="Téléphone"
                    variant="outlined"
                    type="tel"
                    autoComplete="tel"
                    onChange={onChange}
                    fullWidth
                />
            </Box>


            {/* 
            {isAChild ?
                <div className="registration-form-email registration-form-item">
                     <Label>Adresses e-mail<span className="mandatory">*</span></Label>
            <div className="flex">
                <p>Parent 1 : </p>
                <Input type="text" className="emailAddress" id="emailAddress1" name="emailAddress1" autoComplete="email" onChange={onChange} />
            </div>
            <div className="flex">
                <p>Parent 2 : </p>
                <Input type="text" className="emailAddress" id="emailAddress2" name="emailAddress2" autoComplete="email" onChange={onChange} />
            </div>
            {hasEmailError ?
                <Label id="emailError" name="emailError" className="errors">
                    {emailError()}
                </Label>
                : <span />
            } 
                </div>
                :
                <div className="registration-form-email registration-form-item">
                    <Label>Adresses e-mail<span className="mandatory">*</span></Label>
            <Input type="text" className="emailAddress" id="emailAddress" name="emailAddress1" autoComplete="email" onChange={onChange} />
        {hasEmailError ?
            <Label id="emailError" name="emailError" className="errors">
                {emailError()}
            </Label>
            : <span />
        } 
                </div>

            } */}
            {/* Email(s) */}
            {isAChild ? (
                <Box className="registration-form-email registration-form-item">
                    {/* Titre section */}
                    <Box component="label" sx={{ display: "block", mb: 1 }}>
                        Adresses e-mail <span className="mandatory">*</span>
                    </Box>

                    {/* Parent 1 */}
                    <Box
                        // className="flex" 
                        sx={{ alignItems: "center", gap: 1, mb: 1 }}
                    >
                        {/* <Typography component="span">Parent 1 :</Typography> */}
                        <TextField
                            className="emailAddress"
                            id="emailAddress1"
                            name="emailAddress1"
                            // label="Parent 1"
                            placeholder='Parent 1'
                            type="email"
                            autoComplete="email"
                            value={form.emailAddress1}
                            onChange={onChange}
                            fullWidth
                            // Pour aider le label à rester au-dessus, si jamais tu passes un type custom
                            slotProps={{
                                inputLabel: { shrink: true }
                            }}
                        />
                    </Box>

                    {/* Parent 2 */}
                    <Box
                        // className="flex" 
                        sx={{ alignItems: "center", gap: 1 }}>
                        {/* <Typography component="span">Parent 2 :</Typography> */}
                        <TextField
                            className="emailAddress"
                            id="emailAddress2"
                            name="emailAddress2"
                            // label="Parent 2"
                            placeholder='Parent 2'
                            type="email"
                            autoComplete="email"
                            value={form.emailAddress2}
                            onChange={onChange}
                            fullWidth
                            slotProps={{
                                inputLabel: { shrink: true }
                            }}
                        />
                    </Box>

                    {/* Affichage des erreurs */}
                    {emailError ? (
                        <Box component="label" id="emailError" className="errors" sx={{ display: "block", mt: 1 }}>
                            {emailError}
                        </Box>
                    ) : (
                        <span />
                    )}
                </Box>
            ) : (
                <Box className="registration-form-email registration-form-item">
                    {/* Titre section */}
                    <Box component="label" sx={{ display: "block", mb: 1 }}>
                        Adresse e-mail <span className="mandatory">*</span>
                    </Box>

                    {/* Email unique */}
                    <TextField
                        className="emailAddress"
                        id="emailAddress"
                        name="emailAddress"
                        placeholder='Adresse e-mail'
                        type="email"
                        value={form.emailAddress}
                        autoComplete="email"
                        onChange={onChange}
                        fullWidth
                        slotProps={{ inputLabel: { shrink: true } }}
                    />

                    {/* Affichage des erreurs */}
                    {emailError ? (
                        <Box component="label" id="emailError" className="errors" sx={{ display: "block", mt: 1 }}>
                            {emailError}
                        </Box>
                    ) : (
                        <span />
                    )}
                </Box>
            )}

            <div className="registration-form-submit">
                <Button
                    className='button pointer'
                    //   disabled={loading}
                    type="submit"
                //   loading={loading.toString()}
                >
                    {/* <i className="fa fa-spinner fa-spin"></i> */}
                    <span className="text">S'inscrire</span>
                </Button>
                {/* <Input type="button" value="Soumettre" /> */}
            </div>
        </Box>
    )
}

export default RegistrationForm;

